import React, { ReactElement, ReactNode, useState } from "react";

interface CoreTabsProps {
    hasErrors?: boolean;
    errors?: { [x: string]: string[] };
    children?: ReactNode | undefined;
}

export const CoreTabs = ({ hasErrors, errors, children }: CoreTabsProps) => {

    const [state, setState] = useState({
        activeIndex: 0
    })

    const onTabClick = (index: number) => {
        setState({
            ...state,
            activeIndex: index
        })
    }

    const renderHeaders = (): ReactNode => {

        return React.Children.map(children, (child: ReactElement, index) => {

            if (!child) return undefined;

            return React.cloneElement(child, {
                isActive: index == state.activeIndex,
                index,
                onClick: () => onTabClick(index)
            })
        });
    }

    const renderContent = (): ReactNode => {

        return React.Children.map(children, (child: ReactElement, index) => {

            if (!child) return undefined;

            return (
                <div style={{ display: index == state.activeIndex ? "block" : "none" }} className="pt-2">
                    {children[index].props.children}
                </div>
            );
        })
    }

    return (
        <div className="flex flex-column h-full ">
            <ul className="flex flex-row z-10" style={{ marginBottom: '-2px' }}>
                {renderHeaders()}
            </ul>
            <div className="tabs-active-content border-t-2 border-t-gray-200 z-0 bg-white">
                {renderContent()}
            </div>
        </div>
    )
}